import { AccountBindTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

// This file includes different page types that all belong to the same flow (Account Bind)

const AccountBindTrackingSchema: Record<AccountBindTrackingPoint, string> = {
  [AccountBindTrackingPoint.AccountBindingPageView]: '',
  [AccountBindTrackingPoint.AccountBindingContinueButtonClick]: '',
  [AccountBindTrackingPoint.AccountBindingLinkingFailedView]: '',
  [AccountBindTrackingPoint.AccountBindingLinkingFailedContactUsClick]: '',
  [AccountBindTrackingPoint.AccountBindingLinkingFailedOkButtonClick]: '',
  [AccountBindTrackingPoint.ReclaimPhoneClick]: '',
  [AccountBindTrackingPoint.ReclaimPhoneSuccessAction]: '',
  [AccountBindTrackingPoint.ReclaimPhoneFailedPageView]: '',
  [AccountBindTrackingPoint.ReclaimPhoneFailedHelpButtonClick]: '',
  [AccountBindTrackingPoint.ReclaimPhoneFailedContactCustomerServiceClick]: '',
  [AccountBindTrackingPoint.ReclaimPhoneFailedGoHelpCenterClick]: '',
  [AccountBindTrackingPoint.CreateAccountPageView]: '',
  [AccountBindTrackingPoint.CreateAccountContinueButtonClick]: '',
  [AccountBindTrackingPoint.SetPasswordPageView]: '',
  [AccountBindTrackingPoint.SetPasswordConfirmButtonClick]: '',
  [AccountBindTrackingPoint.SetPasswordHelpButtonClick]: '',
  [AccountBindTrackingPoint.SetPasswordSuccessAction]: '',
};

export const getAccountBindAccountBindingPageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindAccountBindingPage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};

export const getAccountBindCreateAccountPageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindCreateAccountPage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};

export const getAccountBindReclaimFailurePageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindReclaimFailurePage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};

export const getAccountBindSetPasswordPageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindSetPasswordPage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};
